module.exports = __webpack_public_path__ + "static/media/nav-icon5.9bc5a6ef.svg";